import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Container } from '@/components/ui/Container';
import { Button } from '@/components/ui/Button';
import { CONTACT_INFO } from '@/utils/constants';

export const CTASection: FC = () => {
  return (
    <section className="py-24 bg-apple-dark">
      <Container>
        <div className="text-center max-w-2xl mx-auto">
          <h2
            className="font-bold text-white mb-4"
            style={{ fontSize: 'clamp(1.875rem, 4vw, 3rem)', lineHeight: 1.1, letterSpacing: '-0.025em' }}
          >
            准备好开始了吗？
          </h2>
          <p
            className="text-white/60 mb-10 text-lg"
            style={{ letterSpacing: '-0.01em' }}
          >
            专业客服团队随时为您提供咨询和技术支持
          </p>

          {/* 按钮组 */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center mb-16">
            <Button
              as={Link}
              to="/contact"
              size="lg"
              className="bg-white text-apple-dark hover:bg-white/90 active:bg-white/80"
            >
              立即联系客服
            </Button>
            <Button
              as={Link}
              to="/docs"
              variant="outline"
              size="lg"
              className="border-white/30 text-white hover:bg-white/10 active:bg-white/20"
            >
              查看安装教程
            </Button>
          </div>

          {/* 联系方式 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-md mx-auto">
            <div className="text-center">
              <div className="text-2xl mb-2">💬</div>
              <div className="text-white/50 text-sm mb-1">微信客服</div>
              <div className="text-white font-medium">扫码添加</div>
            </div>
            <div className="text-center">
              <div className="text-2xl mb-2">⏰</div>
              <div className="text-white/50 text-sm mb-1">服务时间</div>
              <div className="text-white font-medium">{CONTACT_INFO.workingHours}</div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
